import { render } from "./inputFloating.vue?vue&type=template&id=6d38ce1b"
import script from "./inputFloating.vue?vue&type=script&lang=js"
export * from "./inputFloating.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__